const action = {
  type: 'list',
  name: 'action',
  message: 'Choose the usage record action.',
  choices: ['increment', 'set'],
}

export default {
  action,
}
